
import { api } from '@/core/api/'

export default {
  initFilter() {
    return api.get(`api/questionnairesample/initFilters`)
  },
  initFilterstherapyevaluationquestionaire() {
    return api.get(`api/questionnairesample/initFilterstherapyevaluationquestionaire`)
  }
}